import * as React from 'react';
import {
  // Button, Col, Form, FormGroup, Label, 
  Modal,
  // Row 
} from 'reactstrap';
import { Svg } from '../Svg';

interface ICGUModalProps {
  isOpen: boolean;
  toggleWhoWeAreModal: () => void;
}

export const WhoWeAreModal: React.SFC<ICGUModalProps> = ({
  isOpen,
  toggleWhoWeAreModal,
}) => {
  return (
    <Modal size='lg' className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleWhoWeAreModal}
        />
      </div>
      <div className='d-flex flex-column align-items-center pl-5 pr-5 text-center'>
      <div className='d-flex flex-column align-items-center pl-5 pr-5 text-center'>

        <h4>Le conseil à portée de clics</h4>
        <br/>
        <p>Nous sommes une équipe de consultants qui croit fortement dans  <strong className='text-warning'>une nouvelle relation entre freelances et sociétés</strong>.</p>
        <br/>
        <p>Nous ne mettons pas seulement en relation les différentes parties. Nous mettons également à leur disposition  <strong className='text-warning'>nos connaissances en méthodologies d’organisation et de management</strong> pour définir la meilleure façon de mener à bien le projet.</p>
        <br/>
        <p>Nous avons comme ADN  <strong className='text-warning'>la performance et la transparence</strong>. Nous avons donc étudié et mis un place un processus rapide, claire et efficient pour matcher le meilleur consultant avec la mission adéquate.</p>
        <br/>
        <p>Nous sommes persuadés que <strong className='text-warning'>la valeur ajoutée d’une bonne mission est le freelance</strong>. Nous avons orienté notre business model vers une tarification simple et dégressive qui récompense les compétences du consultant qui mène à bien et pérennise la mission.</p>
        <br/>
        <Svg src='logo/logo-color' width={128} height={64} />
        <br/>
        <p>Créée en<strong> 2018, BeAdvize</strong> est une <strong>plateforme</strong> qui facilite la mise en relation et le travail collaboratif entre les consultants et les sociétés partenaires.</p>
        
        <p>Notre plateforme regroupe aujourd’hui un réseau de consultants experts qui mettent à disposition leurs compétences dans le monde du projet.</p>

        </div>
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/WhoWeAreModal.tsx